"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Carousel = function Carousel(_ref) {
  var images = _ref.images,
      maxHeight = _ref.maxHeight,
      _ref$altText = _ref.altText,
      altText = _ref$altText === void 0 ? 'Screenshot' : _ref$altText;
  var maxHeightValue = maxHeight ? "".concat(maxHeight, "px") : '450px';
  return _react.default.createElement("div", {
    className: "carousel-container-outer",
    style: {
      maxWidth: '100%',
      overflowX: 'hidden'
    }
  }, _react.default.createElement("div", {
    className: "carousel-container-inner",
    style: {
      maxHeight: maxHeightValue,
      overflowX: 'scroll',
      overflowY: 'hidden',
      whiteSpace: 'nowrap'
    }
  }, images && images.map(function (el, i) {
    return !!el && _react.default.createElement("div", {
      className: "carousel-image-container",
      key: i,
      style: {
        display: 'inline-block',
        verticalAlign: 'bottom'
      }
    }, _react.default.createElement("img", {
      alt: "".concat(altText, " - ").concat(i),
      className: "carousel-image",
      src: el,
      style: {
        maxHeight: maxHeightValue
      }
    }));
  })));
};

Carousel.propTypes = {
  altText: _propTypes.default.string,
  images: _propTypes.default.arrayOf(_propTypes.default.string),
  maxHeight: _propTypes.default.string
};
var _default = Carousel;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/listing/Carousel.js
// module id = 257
// module chunks = 0